import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core'
import { RestServices } from '../../../../services/rest.services'
import { FormBuilder } from '@angular/forms'
import { AuthService } from '../../../../services/auth.services'
import { SharedServices } from '../../../../services/shared.services'
import { ModalService } from '../../../../services/modal.service'
import * as moment from 'moment'
import { notification } from 'onsenui'
import { getImageStatusUrl, imageUrl } from '../../../../../helper/common'
import { MatrixServices } from '../../../../services/image/matrix.services'
import { compact } from 'lodash'

@Component({
    selector: 'app-modal-timeline-room',
    templateUrl: './modal-timeline-room.component.html',
    styleUrls: ['../../../../stagingcss/root-ui-view.component.css', '../../../../stagingcss/ui-schema-table-form.component.css', './modal-timeline-room.component.css', '../../../../stagingcss/image-viewer.component.css'],
    providers: [MatrixServices]
})
export class ModalTimelineRoomComponent implements OnInit {
    en = {}
    showEN = true
    showEditMessage = 'hidden'
    createDate
    showDate1
    timestampDate
    timestampDateDb

    hiddenModalUser = 'hidden'
    showOption: any
    filterLang: string
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    arrUser
    valueCreator
    valueCreatorDeleted
    optionArr
    styleVisibility: any
    optionArrCopy
    noteMessage
    creatorId
    idRoom
    // image modal
    showNewImage = 'hidden'
    statusImage = false
    faceImage
    url
    imageAdd = []
    arrImage = []
    arrstatusImage = []
    arrImageHash = []
    hiddeniconAddImage = true
    displayRemoveImage = true

    // movies modal
    showNewVideo = 'hidden'
    statusVideo = false
    faceVideo
    videoAdd = []
    arrVideo = []
    arrstatusVideo = []
    arrVideoHash = []
    hiddeniconAddVideo = true
    displayRemoveVideo = true
    pauseVideo = true


    // edit message
    statusSave
    arrRoomId
    idUpdateTimeline

    //matrix
    matrixImage = []
    arrLoading = []
    loading = false
    animationDuration
    statusShowImage = []
    // modal big image
    hiddenModalImage = 'hidden'
    urlBigImage
    styleReponsiveBigImage
    imageUrl = imageUrl
    matrix
    hasBeenEdited = false
    statusESC = false
    statusOns = true
    @ViewChild('myInput') myInputVariable: ElementRef
    @ViewChild('inputFile') myInputImageVariable: ElementRef
    messageTags = []
    selectedTags = []
    isSaveVideo = false
    isSaveImage = false
    converting = false
    defaultCreator
    indexRemoveImage = -1
    indexRemoveVideo = -1

    constructor(private _sharedService: SharedServices, private authData: AuthService, private restApi: RestServices, private formBuider: FormBuilder, private modalService: ModalService, public matrixServices: MatrixServices) {
        this.timestampDateDb = moment(Date.now()).utc().startOf('day').valueOf()
        modalService.changeEmitted$.subscribe(success => {
            this.selectedTags = []
            if (success && success[1] === 'showModalMessage') {
                this.idRoom = success[0]
                this.showEditMessage = 'active'
                if (success[3] === 'edit') {
                    this.statusSave = success[3]
                    this.idUpdateTimeline = success[2]
                    this.getRoomId(success[2])
                } else {
                    this.clearModel()
                }
                this.messageTags = success[4]
            } else if (success && success[1] === 'showModalImage') {
                this.idRoom = success[0]
                this.showNewImage = 'active'
                if (success[3] === 'edit') {
                    this.statusSave = success[3]
                    this.idUpdateTimeline = success[2]
                    this.getRoomId(success[2])
                } else {
                    this.clearModel()
                }
                this.messageTags = success[4]
            } else if (success && success[1] === 'showModalVideo') {
                this.idRoom = success[0]
                this.showNewVideo = 'active'
                if (success[3] === 'edit') {
                    this.statusSave = success[3]
                    this.idUpdateTimeline = success[2]
                    this.getRoomId(success[2])
                } else {
                    this.clearModel()
                }
                this.messageTags = success[4]
            } else if (success && success[1] === 'showBigImage') {
                this.hiddenModalImage = 'active'
                this.loading = true
                setTimeout(() => {
                    this.urlBigImage = success[0]
                    this.matrix = success[2] ? success[2] : [1, 0, 0, 1]
                    this.loading = false
                    // this.items.push(0);
                }, 500)
            }
        })
    }

    ngOnInit() {
        this.arrImage.push(undefined)
        this.arrVideo.push(undefined)
        this.arrstatusImage.push(undefined)
        this.showDate1 = moment().format('YYYY.MM.DD ddd')

    }

    // add or remove selected tags
    toggleTag(item) {
        this.markChanged()
        const found = this.selectedTags.findIndex((e) => {
            return e == item._id
        })
        if (found == -1) {
            this.selectedTags.push(item._id)
        } else {
            this.selectedTags.splice(found, 1)
        }
    }

    // check tag is selected
    checkActiveTag(item) {
        const found = this.selectedTags.findIndex((e) => {
            return e == item._id
        })
        if (found == -1) {
            return false
        }
        return true
    }

    reset(ind) {
        $('#inputVideo' + ind).val('')
    }

    resetImage() {
        this.myInputImageVariable.nativeElement.value = ''
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        let keyPressed = event.keyCode
        if (keyPressed === 27) {
            event.preventDefault()
            if (this.statusESC) {
                this.statusESC = false
                this.hiddenModalUser = 'hidden'
            } else {
                if (this.hasBeenEdited) {
                    this.changeLanguage()
                    notification.confirm({
                        message: this.en['alert-content-discard'],
                        title: '<b>' + this.en['alert-discard'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], 'OK'],
                        callback: i => {
                            if (i === 1) {
                                this.showEditMessage = 'hidden'
                                this.showNewImage = 'hidden'
                                this.showNewVideo = 'hidden'
                                this.resetModel()
                            }
                        },
                    })
                } else {
                    this.showEditMessage = 'hidden'
                    this.showNewImage = 'hidden'
                    this.showNewVideo = 'hidden'
                    this.resetModel()
                }
            }
        }
    }

    hidenModalMessage() {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.showEditMessage = 'hidden'
                        this.resetModel()
                    }
                },
            })
        } else {
            this.showEditMessage = 'hidden'
            this.resetModel()
        }
    }

    hidenModalImage() {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.showNewImage = 'hidden'
                        this.resetModel()
                    }
                },
            })
        } else {
            this.showNewImage = 'hidden'
            this.resetModel()
        }
    }

    // show theme date
    showDate(event) {
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        if (event) {
            const setTimestamp = moment(event['_d'])
            setTimestamp.set({ hours: 10 })
            const timestamp = moment(setTimestamp).utc().startOf('day').valueOf()
            this.showDate1 = moment(timestamp).format('YYYY.MM.DD ddd')
            this.timestampDate = timestamp
            this.timestampDateDb = moment(setTimestamp).utc().startOf('day').valueOf()
            this.createDate = moment(timestamp)
        } else {
            const timestamp = moment(Date.now()).utc().startOf('day').valueOf()
            this.showDate1 = moment(Date.now()).format('YYYY.MM.DD ddd')
            this.timestampDateDb = timestamp
        }
    }

    nextDate(timestampAdd, day) {
        this.markChanged()
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).add(day, 'days').startOf('day').valueOf()
        const timestampDateDb = moment(adDate['_d']).utc().add(addTime, 'hours').add(day, 'days').startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.timestampDateDb = timestampDateDb
        this.showDate1 = showdateAdd
        this.createDate = moment(timestampDate)
    }

    prevDate(timestampAdd, day) {
        this.markChanged()
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).subtract(day, 'days').startOf('day').valueOf()
        const timestampDateDb = moment(adDate['_d']).utc().add(addTime, 'hours').subtract(day, 'days').startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.timestampDateDb = timestampDateDb
        this.showDate1 = showdateAdd
        this.createDate = moment(timestampDate)
    }

    markChanged() {
        this.hasBeenEdited = true
    }

    hidenModal() {
        this.hiddenModalUser = 'hidden'
        this.statusESC = false
    }

    selectOption(id, value) {
        this.showOption = 'showOption_' + id
        this.defaultCreator = id
        if (this.showOption) {
            this.valueCreator = value
            this.valueCreatorDeleted = undefined
            this.creatorId = id
            this.styleVisibility = { visibility: 'visible' }
            this.hidenModal()
            this.markChanged()
        }
    }

    // search language
    search(): void {
        const term = this.filterLang
        this.arrUser = this.optionArrCopy.filter(function(tag) {
            return tag.firstName && tag.firstName.indexOf(term) >= 0 || tag.familyName && tag.familyName.indexOf(term) >= 0
        })
    }

    // get list user
    listUser() {
        this.hiddenModalUser = 'active'
        this.statusESC = true
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                NewRomm: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                    searches: {
                        '{"deleted": {"$ne": true}}': true
                    }
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.arrUser = success['response']['staff']['searches']["{\"deleted\": {\"$ne\": true}}"]
                this.optionArrCopy = this.arrUser.slice() // copy of optionArr
                if (this.defaultCreator) {
                    this.showOption = 'showOption_' + this.defaultCreator                    
                    this.styleVisibility = { visibility: 'visible' }
                }
                if (this.arrUser) {
                    this.arrUser.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                }
            })
        })
    }

    // save message
    saveMessage(statusSave) {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        if (statusSave === 'edit') {
                            this.postMessageEdit()
                            this.hasBeenEdited = false
                        } else {
                            this.postMessage()
                            this.hasBeenEdited = false
                        }
                    }
                },
            })
        } else {
            this.showEditMessage = 'hidden'
            this.resetModel()
        }
    }

    postMessage() {
        const roomId = {}
        roomId['{"roomId":"' + this.idRoom + '"}'] = true
        const resourceData = {
            actions: [{
                type: 'create', id: null, collection: 'roomMessage', value: {
                    note: this.noteMessage,
                    postDate: this.timestampDateDb,
                    roomId: this.idRoom,
                    staff: this.creatorId,
                    tags: this.selectedTags,
                },
            }], status: {
                setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                }, roomMessage: {
                    paths: roomId, searches: roomId,
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showEditMessage = 'hidden'
                const listTimeline = success['response']['roomMessage']['searches']['{"roomId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.noteMessage = undefined
                this.creatorId = undefined
                this.valueCreator = undefined
                this.showOption = undefined
                this.createDate = moment(Date.now())
            })
        })
    }

    postMessageEdit() {
        const roomId = {}
        roomId['{"roomId":"' + this.idRoom + '"}'] = true
        const resourceData = {
            actions: [{
                type: 'update', id: this.idUpdateTimeline, collection: 'roomMessage', value: {
                    note: this.noteMessage,
                    postDate: this.timestampDateDb,
                    roomId: this.idRoom,
                    staff: this.creatorId,
                    tags: this.selectedTags,
                },
            }], status: {
                setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                }, roomMessage: {
                    paths: roomId, searches: roomId,
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showEditMessage = 'hidden'
                const listTimeline = success['response']['roomMessage']['searches']['{"roomId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.noteMessage = undefined
                this.creatorId = undefined
                this.valueCreator = undefined
                this.showOption = undefined
                this.statusSave = undefined
                this.createDate = moment(Date.now())
            })
        })
    }

    // *********************************************************** *************************MODAL IMAGE **********************************************************************//
    allowDropImage(e) {
        e.preventDefault()
    }

    dropImage(ev, i) {
        ev.preventDefault()
        this.indexRemoveImage = -1
        if (this.arrRoomId && this.arrRoomId['images'] && this.arrRoomId['images'].length > 0) {
            if (this.matrixServices.arrFlip.length < this.arrRoomId['images'].length) {
                this.initArrayMatrix(this.arrRoomId['images'])
            }
        }
        const reader = new FileReader()
        reader.readAsDataURL(ev.dataTransfer.files[0])
        const excrptFile: any = 'image/'
        const tmpFile: any = ev.dataTransfer.files[0]
        const typeFile: String = tmpFile['type']
        this.animationDuration = 3500
        if (typeFile.includes(excrptFile) && ev.dataTransfer.files && ev.dataTransfer.files.length > 0) {
            this.markChanged()
            reader.onload = (event: any) => { // called once readAsDataURL is completed
                this.url = event.target.result
                this.arrstatusImage.splice(i, 1, i)
                // this.arrLoading.push(true);
                this.arrLoading[i] = true
                this.statusImage = true
            }
            this.statusShowImage.splice(i, 1, true)
            const fileData = ev.dataTransfer.files.item(0)
            this.authData.authToken().then(tokenReNew => {
                this.restApi.postFile(fileData, tokenReNew).subscribe(success => {
                    // this.matrixServices.arrStyleImage[i] = '';
                    // this.matrixServices.arrRotate[i] = -180;
                    if (this.indexRemoveImage !== -1 && this.indexRemoveImage <= i && i !== 0) {
                        this.arrLoading.splice(i, 1, false)
                        this.statusShowImage.splice(i, 1, false)
                        i = i - 1
                    }
                    this.indexRemoveImage = -1

                    this.faceImage = success['hash']
                    this.matrixImage[i] = [1, 0, 0, 1]
                    const idImage = {
                        id: this.faceImage, matrix: [1, 0, 0, 1],
                    }
                    // this.matrixServices.arrImageHash.push(idImage);
                    this.arrImageHash[i] = idImage
                    this.url = imageUrl + success['hash'] + '?type=medium'
                    this.arrImage[i] = this.url
                    this.arrLoading[i] = false
                    this.statusShowImage.splice(i, 1, false)

                    const _thi = this
                    setTimeout(function() {
                        const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + i)
                        const imageId: HTMLElement = document.getElementById('imageId' + i)
                        _thi.matrixServices.loadSizeImage(imageId, imageWrapper, i, _thi.matrixImage, _thi.arrImage, _thi.arrImageHash)
                    }, 50)
                })
            })
        }
    }

    handleFileInput(files: FileList, event, i) {
        if (event.target.files && event.target.files[0]['type'] === 'image/jpeg' || event.target.files[0]['type'] === 'image/png' || event.target.files[0]['type'] === 'image/tiff') {
        this.indexRemoveImage = -1
            const reader = new FileReader()
            if (this.arrRoomId && this.arrRoomId['images'] && this.arrRoomId['images'].length > 0) {
                if (this.matrixServices.arrFlip.length < this.arrRoomId['images'].length) {
                    this.initArrayMatrix(this.arrRoomId['images'])
                }
            }
            reader.readAsDataURL(event.target.files[0]) // read file as data url

            reader.onload = (event: any) => { // called once readAsDataURL is completed
                this.url = event.target.result
                this.arrstatusImage.splice(i, 1, i)
                // this.arrLoading.push(true);
                this.arrLoading.splice(i, 1, true)
                this.animationDuration = 2800
                this.statusImage = true
            }
            this.statusShowImage.splice(i, 1, true)
            this.authData.authToken().then(tokenReNew => {
                this.restApi.postFile(files.item(0), tokenReNew).subscribe(success => {
                    if (this.indexRemoveImage !== -1 && this.indexRemoveImage <= i && i !== 0) {
                        this.arrLoading.splice(i, 1, false)
                        this.statusShowImage.splice(i, 1, false)
                        i = i - 1
                    }
                    this.indexRemoveImage = -1

                    this.faceImage = success['hash']
                    this.matrixImage.splice(i, 1, [1, 0, 0, 1])
                    const idImage = {
                        id: this.faceImage, matrix: this.matrixImage[i],
                    }
                    // this.matrixServices.arrImageHash.push(idImage);
                    this.arrImageHash.splice(i, 1, idImage)
                    this.url = imageUrl + success['hash'] + '?type=medium'
                    this.arrImage.splice(i, 1, this.url)
                    this.arrLoading.splice(i, 1, false)
                    this.statusShowImage.splice(i, 1, false)
                    // console.log(this.arrImageHash);
                })
            })
        }
    }

    addImage(event) {
        this.resetImage()
        this.markChanged()
        this.arrImage.push(undefined)
        this.arrstatusImage.push(undefined)
        this.statusShowImage.push(false)
        this.displayRemoveImage = false
        this.hiddeniconAddImage = false
        this.statusImage = false
    }

    removeImage(index) {
        this.indexRemoveImage = index
        this.resetImage()
        this.matrixServices.arrStyleImage.splice(index, 1)
        this.matrixServices.arrFlip.splice(index, 1)
        this.arrImage.splice(index, 1)
        this.arrImageHash.splice(index, 1)
        if (this.arrImage.length === 0) {
            this.arrImage.push(undefined)
            this.displayRemoveImage = true
        }
        this.arrLoading[index] = false
        this.arrLoading.splice(index, 1)
        this.matrixServices.arrRotate.splice(index, 1)
        // console.log('index', index);
        // console.log('this.arrImage', this.arrImage);
        // console.log('this.arrImageHash', this.arrImageHash);
        // console.log('this.arrLoading', this.arrLoading);
    }

    saveImage(statusSave) {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        if (statusSave === 'edit') {
                            this.matrixImage = this.matrixServices.matrixImage
                            this.arrImageHash = this.matrixServices.arrImageHash
                            this.arrImage = this.matrixServices.arrImage
                            this.postImageEdit()
                        } else {
                            this.postImage()
                        }
                    }
                },
            })
        } else {
            this.showNewImage = 'hidden'
            this.resetModel()
        }
    }

    postImage() {
        this.arrImageHash = this.arrImageHash.filter((item) => {
            return item !== 'init'
        })
        const roomId = {}
        roomId['{"roomId":"' + this.idRoom + '"}'] = true
        const resourceData = {
            actions: [{
                type: 'create', id: null, collection: 'roomMessage', value: {
                    note: this.noteMessage,
                    postDate: this.timestampDateDb,
                    roomId: this.idRoom,
                    staff: this.creatorId,
                    images: compact(this.arrImageHash),
                    type: 'image',
                    tags: this.selectedTags,
                },
            }], status: {
                setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                }, roomMessage: {
                    paths: roomId, searches: roomId,
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showNewImage = 'hidden'
                const listTimeline = success['response']['roomMessage']['searches']['{"roomId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.noteMessage = undefined
                this.creatorId = undefined
                this.valueCreator = undefined
                this.showOption = undefined
                this.arrImage = [undefined]
                this.matrixServices.resetMatrix()
                this.arrImageHash = []
                this.createDate = moment(Date.now())
                this.matrixImage = []
                this.statusShowImage = []
                this.hasBeenEdited = false
            })
        })
    }

    postImageEdit() {
        this.arrImageHash = this.arrImageHash.filter((item) => {
            return item !== 'init'
        })
        const roomId = {}
        roomId['{"roomId":"' + this.idRoom + '"}'] = true
        const resourceData = {
            actions: [{
                type: 'update', id: this.idUpdateTimeline, collection: 'roomMessage', value: {
                    note: this.noteMessage,
                    postDate: this.timestampDateDb,
                    roomId: this.idRoom,
                    staff: this.creatorId,
                    images: compact(this.arrImageHash),
                    type: 'image',
                    tags: this.selectedTags,
                },
            }], status: {
                setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                }, roomMessage: {
                    paths: roomId, searches: roomId,
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showNewImage = 'hidden'
                const listTimeline = success['response']['roomMessage']['searches']['{"roomId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.noteMessage = undefined
                this.creatorId = undefined
                this.valueCreator = undefined
                this.showOption = undefined
                this.arrImage = [undefined]
                this.statusSave = undefined
                this.arrImageHash = []
                this.createDate = moment(Date.now())
                this.matrixServices.resetMatrix()
                this.matrixImage = []
                this.statusShowImage = []
                this.hasBeenEdited = false
            })
        })
    }

    allowDrop(event) {
        event.preventDefault()
    }

    drop(ev, i) {
        ev.preventDefault()
        this.indexRemoveVideo = -1
        if (this.arrVideo.length > 0) {
            const reader = new FileReader()
            reader.readAsDataURL(ev.dataTransfer.files[0])
            const excrptFile: any = 'video'
            const tmpFile: any = ev.dataTransfer.files[0]
            const typeFile: String = tmpFile['type']
            //this.animationDuration = 3500


            if (typeFile.includes(excrptFile)) {
                this.markChanged()
                reader.onload = (event: any) => { // called once readAsDataURL is completed
                    this.url = event.target.result
                    this.arrstatusVideo.splice(i, 1, i)
                    this.statusVideo = true
                    // this.arrLoading.push(true);
                    this.arrLoading[i] = true
                    this.animationDuration = 1000
                    this.converting = false
                    setTimeout(() => {
                        this.converting = true
                    }, 1500)

                }
                this.statusShowImage.splice(i, 1, true)
                const fileData = ev.dataTransfer.files.item(0)
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(fileData, tokenReNew).subscribe(
                        success => {
                            if (this.indexRemoveVideo !== -1 && this.indexRemoveVideo <= i && i !== 0) {
                                this.arrLoading.splice(i, 1, false)
                                this.statusShowImage.splice(i, 1, false)
                                i = i - 1
                            }
                            this.indexRemoveVideo = -1

                            this.faceVideo = success['hash']
                            const idVideo = {
                                id: this.faceVideo,
                            }
                            this.converting = false
                            this.arrVideoHash.splice(i, 1, idVideo)
                            this.url = imageUrl + success['hash'] + '?type=medium'
                            this.arrVideo.splice(i, 1, this.url)
                            this.arrLoading[i] = false
                            this.statusShowImage.splice(i, 1, false)
                        },
                    )
                })
            }
        }
    }

    // *********************************************************** *************************MODAL VIDEO **********************************************************************//
    handleFileInputVideo(files: FileList, event, i) {
        this.indexRemoveVideo = -1
        if (event.target.files && event.target.files[0]['type'] === 'video/mp4') {
            const reader = new FileReader()
            this.isSaveVideo = true
            reader.readAsDataURL(event.target.files[0]) // read file as data url

            reader.onload = (event: any) => { // called once readAsDataURL is completed
                this.url = event.target.result
                this.arrstatusVideo.splice(i, 1, i)
                this.statusVideo = true
                // this.arrLoading.push(true);
                this.arrLoading.splice(i, 1, true)
                this.animationDuration = 1000
                this.converting = false
                setTimeout(() => {
                    this.converting = true
                }, 1500)
            }
            this.statusShowImage.splice(i, 1, true)            
            this.authData.authToken().then(tokenReNew => {
                this.restApi.postFile(files.item(0), tokenReNew).subscribe(success => {
                    if (this.indexRemoveVideo !== -1 && this.indexRemoveVideo <= i && i !== 0) {                        
                        this.arrLoading.splice(i, 1, false)
                        this.statusShowImage.splice(i, 1, false)
                        i = i - 1
                    }
                    this.indexRemoveVideo = -1

                    this.faceVideo = success['hash']
                    const idVideo = {
                        id: this.faceVideo,
                    }
                    this.arrVideoHash.splice(i, 1, idVideo)
                    this.url = imageUrl + success['hash'] + '?type=medium'
                    this.arrVideo.splice(i, 1, this.url)
                    this.arrLoading.splice(i, 1, false)
                    this.converting = false
                    this.statusShowImage.splice(i, 1, false)
                })
            })
        }
    }

    addMovies(event) {
        this.arrVideo.push(undefined)
        this.arrVideoHash.push(undefined)
        this.arrstatusVideo.push(undefined)
        this.displayRemoveVideo = false
        this.hiddeniconAddVideo = false
        this.statusVideo = false
        this.statusShowImage.push(false)
    }

    removeVideo(index) {
        // this.isSaveVideo = false
        this.indexRemoveVideo = index
        this.arrVideo.splice(index, 1)
        this.arrVideoHash.splice(index, 1)
        this.arrLoading[index] = false
        this.arrLoading.splice(index, 1)
        if (this.arrVideo.length === 0) {
            this.arrVideo.push(undefined)
            this.displayRemoveVideo = true
        }
    }

    removeMovie(i) {
        $('#inputVideo' + i).val('')
        this.arrLoading[i] = false
        this.arrVideo.splice(i, 1, undefined)
        this.arrVideoHash.splice(i, 1, undefined)
    }

    sortVideo(index, action) {
        if (action === 'up') {
            const br1 = this.arrVideo[index - 1]
            const br2 = this.arrVideo[index]
            const br3 = this.arrstatusVideo[index - 1]
            const br4 = this.arrstatusVideo[index]
            const arrImageHash_1 = this.arrVideoHash[index - 1]
            const arrImageHash = this.arrVideoHash[index]
            this.arrVideo.splice(index - 1, 2, br2, br1)
            this.arrstatusVideo.splice(index - 1, 2, br3, br4)
            this.arrVideoHash.splice(index - 1, 2, arrImageHash_1, arrImageHash)
        } else if (action === 'down') {
            const br1 = this.arrVideo[index]
            const br2 = this.arrVideo[index + 1]
            const br3 = this.arrstatusVideo[index + 1]
            const br4 = this.arrstatusVideo[index]
            const arrImageHash_1 = this.arrVideoHash[index + 1]
            const arrImageHash = this.arrVideoHash[index]
            this.arrVideo.splice(index, 2, br2, br1)
            this.arrstatusVideo.splice(index, 2, br3, br4)
            this.arrVideoHash.splice(index, 2, arrImageHash_1, arrImageHash)
        } else {
        }
    }

    hidenModalVideo() {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.showNewVideo = 'hidden'
                        this.resetModel()
                    }
                },
            })
        } else {
            this.showNewVideo = 'hidden'
            this.resetModel()
        }
    }

    saveVideo(statusSave) {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        if (statusSave === 'edit') {
                            this.postVideoEdit()
                        } else {
                            this.postVideo()
                        }
                    }
                },
            })
        } else {
            this.showNewVideo = 'hidden'
            this.resetModel()
        }
    }

    postVideo() {
        const roomId = {}
        roomId['{"roomId":"' + this.idRoom + '"}'] = true
        const resourceData = {
            actions: [{
                type: 'create', id: null, collection: 'roomMessage', value: {
                    note: this.noteMessage,
                    postDate: this.timestampDateDb,
                    roomId: this.idRoom,
                    staff: this.creatorId,
                    images: compact(this.arrVideoHash),
                    type: 'movie',
                    tags: this.selectedTags,
                },
            }], status: {
                setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                }, roomMessage: {
                    paths: roomId, searches: roomId,
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showNewVideo = 'hidden'
                const listTimeline = success['response']['roomMessage']['searches']['{"roomId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.noteMessage = undefined
                this.creatorId = undefined
                this.valueCreator = undefined
                this.showOption = undefined
                this.arrVideo = [undefined]
                this.arrVideoHash = []
                this.statusShowImage = []
                this.createDate = moment(Date.now())
                this.hasBeenEdited = false
            })
        })
    }

    postVideoEdit() {
        const roomId = {}
        roomId['{"roomId":"' + this.idRoom + '"}'] = true
        const resourceData = {
            actions: [{
                type: 'update', id: this.idUpdateTimeline, collection: 'roomMessage', value: {
                    note: this.noteMessage,
                    postDate: this.timestampDateDb,
                    roomId: this.idRoom,
                    staff: this.creatorId,
                    images: compact(this.arrVideoHash),
                    type: 'movie',
                    tags: this.selectedTags,
                },
            }], status: {
                setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                }, roomMessage: {
                    paths: roomId, searches: roomId,
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showNewVideo = 'hidden'
                const listTimeline = success['response']['roomMessage']['searches']['{"roomId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.noteMessage = undefined
                this.creatorId = undefined
                this.valueCreator = undefined
                this.showOption = undefined
                this.arrVideo = [undefined]
                this.statusSave = undefined
                this.arrVideoHash = []
                this.statusShowImage = []
                this.createDate = moment(Date.now())
                this.hasBeenEdited = false
            })
        })
    }

    // ****************************************************************** EDIT MESSAGE ***************************************************** //
    getRoomId(idRoom) {
        const resourceUrl = 'resource'
        const roomId = {}
        roomId['{"roomId":"' + this.idRoom + '"}'] = true
        const map = {}
        map[idRoom] = true
        const resourceData = {
            actions: [], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                }, roomMessage: {
                    map, paths: roomId, searches: roomId,
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.arrRoomId = success['response']['roomMessage']['map'][idRoom]
                if (this.arrRoomId['images'] && Array.isArray(this.arrRoomId['images'])) {
                    this.initArrayMatrix(this.arrRoomId['images'])
                }
                this.createDate = moment(this.arrRoomId['postDate'])
                this.timestampDate = this.arrRoomId['postDate']
                this.noteMessage = this.arrRoomId['note']
                this.selectedTags = this.arrRoomId['tags'] ? this.arrRoomId['tags'] : []
                const staff = success['response']['staff']['paths']['{}']
                for (let i = 0; i <= staff.length; i++) {
                    if (staff[i] && staff[i]['_id'] === this.arrRoomId.staff) {
                        this.valueCreator = (staff[i].firstName || '') + ' ' + (staff[i].familyName || '')
                        this.valueCreatorDeleted = staff[i].deleted
                    }
                }
                this.creatorId = this.arrRoomId.staff
                this.defaultCreator = this.arrRoomId.staff
                // this.arrImage = this.arrRoomId['images'];
                // if (this.arrRoomId['images'] && this.arrRoomId['type'] === 'image') {
                //     this.arrImage = [];
                //     for (let i = 0; i <= this.arrRoomId['images'].length; i++) {
                //         if (this.arrRoomId['images'][i] && this.arrRoomId['images'][i]['id']) {
                //             this.url = imageUrl + this.arrRoomId['images'][i]['id'] + '?type=medium';
                //             // this.arrImage.push(this.url);
                //             // this.matrixImage.push(this.arrRoomId['images'][i]['matrix']);
                //             // this.arrLoading.push(true);
                //             // this.animationDuration = 300;
                //         }
                //     }
                //     // this.displayRemoveImage = false;
                //     // this.arrImageHash = this.arrRoomId['images'];
                //     // if (this.arrImage.length === 0) {
                //     //     this.arrImage.push(undefined);
                //     //     this.displayRemoveImage = true;
                //     // }
                // }

                if (this.arrRoomId['images'] && this.arrRoomId['type'] === 'movie') {
                    this.arrVideo = []
                    for (let i = 0; i <= this.arrRoomId['images'].length; i++) {
                        if (this.arrRoomId['images'][i] && this.arrRoomId['images'][i]['id']) {
                            this.url = imageUrl + this.arrRoomId['images'][i]['id'] + '?type=medium'
                            this.arrVideo.push(this.url)
                            // this.arrLoading.push(true);
                            // this.animationDuration = 300;
                        }
                    }
                    this.displayRemoveVideo = false
                    this.arrVideoHash = this.arrRoomId['images']
                    if (this.arrVideo.length === 0) {
                        this.arrVideo.push(undefined)
                        this.displayRemoveVideo = true
                    }
                }

                setTimeout(() => {
                    // this.loading = false;
                    if (this.arrLoading.length) {
                        for (let a = 0; a < this.arrLoading.length; a++) {
                            this.arrLoading.splice(a, 1, false)
                        }
                    }
                }, 500)
            })
        })
    }

    initArrayMatrix(arrayGeneral: any[] = []) {
        this.animationDuration = 300
        this.displayRemoveImage = false
        this.arrImageHash = []
        this.arrImage = []
        //matrix
        this.matrixImage = []
        const matrix = [1, 0, 0, 1]
        const arrRotate: any[] = []
        const arrStyleImage: any[] = []
        const arrFlip: any[] = []
        const jsonFlip: any = {}
        jsonFlip['horizontalFlip'] = 1
        jsonFlip['verticalFlip'] = 1
        this.arrLoading = []
        const tpmArrImageHash: any[] = []
        const tmpArrayMatrixImage: any[] = []
        const tmpArrImage: any[] = []
        const dxdyMatrix: any[] = []

        if (arrayGeneral && arrayGeneral.length > 0) {
            arrayGeneral.forEach((el, i) => {
                if (el) {
                    if (el && el['matrix']) {
                        tmpArrayMatrixImage.push(el['matrix'])
                    } else {
                        tmpArrayMatrixImage.push(matrix)
                    }
                    tpmArrImageHash.push(el)
                    if (el && el['id']) {
                        this.url = imageUrl + el['id'] + '?type=medium'
                        tmpArrImage.push(this.url)
                    }
                    // this.arrImageHash.push({});
                    arrRotate.push(0)
                    arrStyleImage.push('')
                    arrFlip.push(jsonFlip)
                    dxdyMatrix.push(0)
                    // this.arrayMatrixImage.push(matrix);
                    this.arrLoading.push(false)
                }
            })
            this.matrixImage = jQuery.extend(true, [], tmpArrayMatrixImage)
            this.arrImageHash = jQuery.extend(true, [], tpmArrImageHash)
            this.arrImage = jQuery.extend(true, [], tmpArrImage)
            if (this.matrixServices.arrFlip.length < arrFlip.length) {
                this.matrixServices.arrImageHash = jQuery.extend(true, [], this.arrImageHash)
                this.matrixServices.arrRotate = jQuery.extend(true, [], arrRotate)
                this.matrixServices.arrStyleImage = jQuery.extend(true, [], arrStyleImage)
                this.matrixServices.arrFlip = jQuery.extend(true, [], arrFlip)
                this.matrixServices.dXdYMatrixCanvas = jQuery.extend(true, [], dxdyMatrix)
            }
        }
        if (this.arrImage.length === 0) {
            this.arrImage.push(undefined)
            this.displayRemoveImage = true
        }
    }

    // ************************************************************* REMOVE TIMELINNE ************************************************************ //
    removeTimeline(idTimeLine) {
        this.changeLanguage()
        notification.confirm({
            message: this.en['alert-content-2'],
            title: '<b>' + this.en['alert-remove'] + '</b>',
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], 'OK'],
            callback: i => {
                if (i === 1) {  // here this is not cancelled.  1 is correct.
                    this.removeTimelineId(idTimeLine)
                }
            },
        })
    }

    removeTimelineId(idTimeLine) {
        const roomId = {}
        roomId['{"roomId":"' + this.idRoom + '"}'] = true
        const resourceData = {
            actions: [{
                type: 'remove', id: idTimeLine, collection: 'roomMessage',
            }], status: {
                setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                }, roomMessage: {
                    paths: roomId, searches: roomId,
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showNewVideo = 'hidden'
                this.showEditMessage = 'hidden'
                this.showNewImage = 'hidden'
                const listTimeline = success['response']['roomMessage']['searches']['{"roomId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.noteMessage = undefined
                this.creatorId = undefined
                this.valueCreator = undefined
                this.showOption = undefined
                this.arrVideo = [undefined]
                this.arrImage = [undefined]
                this.statusSave = undefined
                this.createDate = moment(Date.now())
                this.matrixImage = []
                this.statusShowImage = []
            })
        })
    }

    pauseVid(event, pause) {
        const video = event.target
        if (pause) {
            video.play()
            this.pauseVideo = false
        } else {
            video.pause()
            this.pauseVideo = true
        }
    }

    downloadMovie(i) {
        const tmp = getImageStatusUrl(this.arrVideoHash[i]['id'])
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_get(tmp, tokenReNew).subscribe(res => {
                this.arrLoading[i] = true
                this.animationDuration = 4000
                var xhr = new XMLHttpRequest()
                xhr.open('GET', res['url'], true)
                xhr.responseType = 'blob'
                const _thi = this

                xhr.onprogress = function(event) {
                    if (event.lengthComputable) {
                        var percentComplete = (event.loaded / event.total) * 100
                        // console.log(percentComplete);
                        // console.log(event.loaded);
                    }
                }

                xhr.onload = function(event) {
                    if (this != undefined && this['status'] != undefined && this['status'] == 200) {
                        _thi.saveBlob(this['response'], _thi.arrVideoHash[i]['id'], i)
                    }
                }

                xhr.send()
            })
        })
    }

    saveBlob(response, fileName, index) {
        if (navigator.msSaveBlob) {
            //OK for IE10+
            navigator.msSaveBlob(response, fileName)
        } else {
            this.html5Saver(response, fileName, index)
        }
    }

    html5Saver(blob, fileName, index) {
        this.changeLanguage()
        var a = document.getElementById('download')
        document.body.appendChild(a)
        var url = window.URL.createObjectURL(blob)
        a.setAttribute('href', url)
        a.setAttribute('download', fileName)
        this.arrLoading[index] = false
        notification.confirm({
            message: this.en['download-notice'],
            title: `<b>${ this.en['download'] }</b>`,
            buttonLabels: ['OK'],
            callback: i => {
                if (i === 0) {  // here this is not cancelled.  1 is correct.
                    a.click()
                }
            },
        })
    }

    hiddenModalBigImage() {
        this.hiddenModalImage = 'hidden'
        this.urlBigImage = undefined
    }

    // big Image
    reponsiveImage(sizeImage, widthBigImage, matrixImage) {
        const n1 = (widthBigImage.offsetHeight / sizeImage.clientHeight) * (matrixImage[0]) // n1
        const n2 = (widthBigImage.offsetHeight / sizeImage.clientWidth) * (matrixImage[1]) // n2
        const n3 = (widthBigImage.offsetHeight / sizeImage.clientWidth) * (matrixImage[2]) // n3
        const n4 = (widthBigImage.offsetHeight / sizeImage.clientHeight) * (matrixImage[3]) // n4
        const n5 = (widthBigImage.offsetWidth - sizeImage.clientWidth) / 2
        const n6 = (widthBigImage.offsetHeight - sizeImage.clientHeight) / 2
        this.styleReponsiveBigImage = {
            'transform': 'matrix(' + n1 + ', ' + n2 + ', ' + n3 + ', ' + n4 + ',' + n5 + ',' + n6 + ')',
        }
    }

    showBigImage(id, matrix) {
        const arrImage = [id, 'showBigImage', matrix]
        this._sharedService.emitChange(arrImage)
    }

    removePhoto(index) {
        $('#inputImage' + index).val('')
        this.arrImage.splice(index, 1, undefined)
        this.arrImageHash.splice(index, 1, undefined)
        this.arrLoading.splice(index, 1, false)
        // console.log('this.arrImage', this.arrImage);
        // console.log('this.arrImageHash', this.arrImageHash);
        // console.log('this.arrLoading', this.arrLoading);
    }

    resetModel() {
        this.noteMessage = undefined
        this.creatorId = undefined
        this.valueCreator = undefined
        this.valueCreatorDeleted = undefined
        this.showOption = undefined
        this.statusSave = undefined

        this.arrVideo = [undefined]
        this.matrixServices.resetMatrix()
        this.arrVideoHash = []
        this.statusShowImage = []

        this.arrImage = [undefined]
        this.arrImageHash = []
        this.matrixImage = []
        this.createDate = moment(Date.now())
        this.hasBeenEdited = false
        this.selectedTags = []

        this.arrRoomId = {};
        this.matrixServices.arrStyleImage = [];
    }


    clearModel() {
        this.defaultCreator = undefined
        this.styleVisibility = { visibility: 'hidden' }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/communication-room/timeline/modal-timeline-room.component.ts